import AxiosClient from "../../../services/axios.services";

class FactorTemplateServices {
  getFactorTemplate = (params) =>
    AxiosClient.get("/api/app/evaluacion_factor_plantilla_encabezado/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getFactorTemplateById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_factor_plantilla_encabezado/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveFactorTemplate = (data) =>
    AxiosClient.post("/api/app/evaluacion_factor_plantilla_encabezado/", data, {
      headers: { "Content-Type": "application/json" },
    });
  copyFactorTemplate = (data) =>
    AxiosClient.post("/api/app/copiado_evaluacion_plantilla_factor/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editFactorTemplate = (id, data) =>
    AxiosClient.put(
      `/api/app/evaluacion_factor_plantilla_encabezado/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteFactorTemplate = (id) =>
    AxiosClient.delete(
      `/api/app/evaluacion_factor_plantilla_encabezado/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new FactorTemplateServices();
